var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDipCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_11cd3d58dc6f018810ba61732ea997f2165586e1f6165908b2d1d6edd07949cc",
    x1: 83.109,
    y1: 32.926,
    x2: 115.021,
    y2: 32.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M99.719 101.662h25.157a3.353 3.353 0 013.357 3.352v4.212a3.358 3.358 0 01-3.357 3.357H74.04a3.358 3.358 0 01-3.357-3.357v-4.212a3.353 3.353 0 013.357-3.352h25.678"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M110.392 151.411H88.525a9.386 9.386 0 01-9.302-8.136l-4.121-30.694h48.711l-4.121 30.694a9.384 9.384 0 01-9.302 8.136zM99.278 100.052V82.466M115.045 57.403c0 .334-.009.659-.033.985a15.676 15.676 0 01-2.262 7.22 16.033 16.033 0 01-4.023 4.424 15.835 15.835 0 01-5.509 2.646c-1.26.317-2.579.493-3.939.493-1.252 0-2.471-.142-3.639-.426a15.46 15.46 0 01-5.451-2.462 15.814 15.814 0 01-4.224-4.424 15.585 15.585 0 01-2.396-7.178 12.755 12.755 0 01-.058-1.277c0-1.628.242-3.189.701-4.666a15.677 15.677 0 012.905-5.375 15.995 15.995 0 016.077-4.516 15.773 15.773 0 015.868-1.202c.075-.008.142-.008.217-.008 2.045 0 3.998.392 5.793 1.093a15.884 15.884 0 016.177 4.407 15.711 15.711 0 013.798 10.267z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M112.775 38.28l.801-4.599c1.377-7.929-4.733-15.191-12.779-15.191h-3.464c-7.904 0-13.973 7.011-12.837 14.832l.768 5.334 1.26 8.706h.593M99.061 41.644V31.361",
    stroke: "url(#SVGID_0_11cd3d58dc6f018810ba61732ea997f2165586e1f6165908b2d1d6edd07949cc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M85.264 38.656l-4.123-2.179c-7.12-3.764-15.909-.192-18.396 7.462l-1.077 3.297c-2.437 7.512 2.354 15.45 10.141 16.785l5.317.918 8.656 1.494.184-.576a15.596 15.596 0 01-2.396-7.178 12.755 12.755 0 01-.058-1.277c0-1.628.242-3.188.701-4.666a15.677 15.677 0 012.905-5.375 15.999 15.999 0 016.076-4.516M84.212 52.737l-9.766-3.172",
    stroke: "url(#SVGID_0_11cd3d58dc6f018810ba61732ea997f2165586e1f6165908b2d1d6edd07949cc)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M77.126 64.94l-3.355 3.255c-5.776 5.609-5.1 15.066 1.411 19.799l2.805 2.037c3.965 2.88 8.931 3.163 13.021 1.294a12.878 12.878 0 006.085-5.743l2.512-4.766.242-.467 3.856-7.32-.484-.351c-1.26.317-2.579.492-3.94.492-1.252 0-2.471-.142-3.639-.426a15.448 15.448 0 01-5.45-2.462 15.797 15.797 0 01-4.223-4.424 15.596 15.596 0 01-2.396-7.178M90.188 70.282l-6.043 8.322",
    stroke: "url(#SVGID_0_11cd3d58dc6f018810ba61732ea997f2165586e1f6165908b2d1d6edd07949cc)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M95.639 72.744c1.169.284 2.387.426 3.639.426 1.361 0 2.679-.175 3.94-.492a15.835 15.835 0 005.509-2.646 16.019 16.019 0 004.023-4.424 15.672 15.672 0 002.262-7.22l.492-.359 6.135 6.302 3.764 3.865c5.509 5.659 4.716 14.899-1.678 19.54l-2.805 2.037c-4.082 2.963-9.223 3.18-13.363 1.135a12.85 12.85 0 01-5.901-5.91l-2.053-4.182M114.761 78.345l-6.034-8.313",
    stroke: "url(#SVGID_0_11cd3d58dc6f018810ba61732ea997f2165586e1f6165908b2d1d6edd07949cc)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M121.639 64.331l4.624-.659c7.963-1.144 12.979-9.19 10.492-16.852l-1.068-3.297c-2.446-7.512-10.984-11.118-18.071-7.621l-4.841 2.379-7.888 3.89.184.559a15.884 15.884 0 016.177 4.407 15.711 15.711 0 013.798 10.267c0 .334-.008.659-.033.985a15.672 15.672 0 01-2.262 7.22M123.985 49.148l-9.774 3.18",
    stroke: "url(#SVGID_0_11cd3d58dc6f018810ba61732ea997f2165586e1f6165908b2d1d6edd07949cc)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 99.278,
    cy: 57.403,
    r: 15.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M102.844 54.277s-.575-3.717-3.564-3.757c-2.99-.04-3.843 3.658-3.843 3.658l7.682 6.144",
    stroke: "url(#SVGID_0_11cd3d58dc6f018810ba61732ea997f2165586e1f6165908b2d1d6edd07949cc)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M95.713 60.222s.575 3.717 3.564 3.757c2.99.04 3.843-3.658 3.843-3.658M99.411 47.362l-.042 3.159M99.188 63.978l-.043 3.159",
    stroke: "url(#SVGID_0_11cd3d58dc6f018810ba61732ea997f2165586e1f6165908b2d1d6edd07949cc)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDipCompanies);
export default __webpack_public_path__ + "static/media/dipCompanies.09a9af2c7835bcb99f398f311372801d.svg";
export { ForwardRef as ReactComponent };